import { NgModule } from '@angular/core';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
	imports: [
		MatCheckboxModule,
		MatRadioModule,
		MatButtonModule,
		MatButtonToggleModule,
		MatMenuModule,
		MatToolbarModule,
		MatIconModule,
		MatCardModule,
		MatSliderModule,
		MatSnackBarModule,
		MatDialogModule,
		MatTabsModule,
		MatDatepickerModule,
		MatInputModule,
		MatListModule,
		MatPaginatorModule,
		MatProgressSpinnerModule,
		MatSelectModule,
		MatSidenavModule,
		MatStepperModule,
		MatSortModule,
		MatTableModule,
		FormsModule,
		ReactiveFormsModule,
		MatAutocompleteModule,
		MatGridListModule,
		MatTreeModule,
		MatChipsModule,
		MatExpansionModule,
		MatSlideToggleModule
	],
	exports: [
		MatCheckboxModule,
		MatRadioModule,
		MatButtonModule,
		MatButtonToggleModule,
		MatMenuModule,
		MatToolbarModule,
		MatIconModule,
		MatCardModule,
		MatSliderModule,
		MatSnackBarModule,
		MatDialogModule,
		MatTabsModule,
		MatDatepickerModule,
		MatInputModule,
		MatListModule,
		MatPaginatorModule,
		MatProgressBarModule,
		MatProgressSpinnerModule,
		MatSelectModule,
		MatSidenavModule,
		MatStepperModule,
		MatSortModule,
		MatTableModule,
		FormsModule,
		ReactiveFormsModule,
		MatAutocompleteModule,
		MatGridListModule,
		MatTreeModule,
		MatChipsModule,
		MatExpansionModule,
		MatSlideToggleModule
	]
})
export class MaterialModule {}
